import { useContext } from 'react'

import { SettingsContext } from '@provider/Parametrization/SettingsProvider'

import { ISettingsContext } from '@base/@types/providers/Parametrization/SettingsProvider'

export default function useParametrizationSettings(): ISettingsContext {
  const context = useContext(SettingsContext)

  return context
}
